import { AbstractCustomField } from '@/components/Fields/dataObjects/AbstractCustomField'
import { CustomFieldCustomFieldOptionInput, CustomFieldType } from '@/gql/graphql'

export class SingleSelect extends AbstractCustomField {
  fieldType: CustomFieldType = CustomFieldType.SingleSelect

  optionsForGraphQL(): CustomFieldCustomFieldOptionInput[] {
    return this.customFieldOptions.map((option: { id; value }, index) => ({
      option: option.id,
      value: option.value,
      displayOrder: index + 1,
    }))
  }
}
